import axios from "axios";
import { API_HEADERS, ORDER_SHIPMENTS_BASE_URL } from "../../constants";

export const getPDF = async (orderItemDataPdf: any) => {
  try {
    const response = await axios.post(
      `${ORDER_SHIPMENTS_BASE_URL}/pdfGenerator`,
      { ...orderItemDataPdf },
      {
        headers: API_HEADERS,
        responseType: "blob", // handle binary response
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to generate PDF");
  }
};
